module.exports = __webpack_public_path__ + "2839062560eb2e2df467878bf032e8b7.svg";